import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { ICommonControlWithMinMax } from "./ICommonInputsControls";
import { NumberInput } from "../../atoms/forms/NumberInput";
import * as AanwezighedenIcon from "../../atoms/icons/AanwezigenIcon";
import { useTranslation } from 'react-i18next';


export enum AanwezigenType {
    Default = "Default",
    Professioneel = "Professioneel",
    NietProfessioneel = "NietProfessioneel",
}

// All the incoming values
interface IProps {
    AanwezigenType?: AanwezigenType;
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonControlWithMinMax<number>;
export const AanwezigenInput = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t } = useTranslation('datatypes');
    
    const type = props.AanwezigenType || AanwezigenType.Default;
    
    const icon = (() => {
        switch (type) {
            case AanwezigenType.Professioneel:
                return <AanwezighedenIcon.AanwezigenProfessioneel />;
            case AanwezigenType.NietProfessioneel:
                return <AanwezighedenIcon.AanwezigenNietProfessioneel />;
            default:
                return <AanwezighedenIcon.AanwezigenDefault />;
        }
    })();

    const placeholderText = (() => {
        switch (type) {
            case AanwezigenType.Professioneel:
                return t('aanwezigenPlaceholderProfessioneel');
            case AanwezigenType.NietProfessioneel:
                return t('aanwezigenPlaceholderNietProfessioneel');
            default:
                return t('aanwezigenPlaceholderDefault');
        }
    })();

    const label = props.label || (() => {
        switch (type) {
            case AanwezigenType.Professioneel:
                return t('aanwezigenLabelProfessioneel');
            case AanwezigenType.NietProfessioneel:
                return t('aanwezigenLabelNietProfessioneel');
            default:
                return t('aanwezigenLabelDefault');	
        }
    })() || t('aanwezigenLabelDefault') || "Aantal aanwezigen";

    return (<NumberInput

            {...props}

            label={label}        
            placeholder={placeholderText}
            icon={icon}
            minValue={props.minValue || 0}

        />
    )
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));